import { forwardRef, ForwardRefRenderFunction } from 'react'
import { SelectStyled, FormControlStyled, ChevronDownIconStyled } from './style'
import { FormHelperText, MenuItem } from '@mui/material'
import { SelectInputProps } from '@mui/material/Select/SelectInput'
import { OptionProps } from '../Select/Select'

export interface SelectPillProps {
  value: string | number
  name: string
  label?: string
  options?: Array<OptionProps>
  onChange?: SelectInputProps<unknown>['onChange']
  error?: object | string | null
  disabled?: boolean
  id?: string
}

const SelectComponent: ForwardRefRenderFunction<HTMLInputElement, SelectPillProps> = (
  { value, name, label, onChange, options = [], error = null, disabled, id },
  ref
) => {
  return (
    <FormControlStyled variant="outlined" {...(error && { error: true })}>
      <SelectStyled
        variant="standard"
        inputRef={ref}
        data-testid="select-pill"
        name={name}
        displayEmpty
        value={value}
        onChange={onChange}
        disabled={disabled}
        disableUnderline
        inputProps={{ id: id, IconComponent: ChevronDownIconStyled }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
          },
          PaperProps: {
            sx: {
              '& li': {
                fontSize: '14px'
              }
            }
          }
        }}
      >
        {!value && (
          <MenuItem disabled value="">
            <em>{label}</em>
          </MenuItem>
        )}
        {options.map((option, key) => (
          <MenuItem key={key} value={option.value}>
            <span>{option.title}</span>
          </MenuItem>
        ))}
      </SelectStyled>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControlStyled>
  )
}

export const SelectPill = forwardRef(SelectComponent)
